/** biome-ignore-all lint/a11y/noStaticElementInteractions: don't need to justify */
import React from 'react';
import { IActionMenuItem, Theme, WithStyle } from 'rewire-ui';
import Breadcrumbs from '../main-navigation/Breadcrumbs';
import MainContentToolbar from '../main-navigation/MainContentToolbar';
import ScheduleControls from '../schedule/ScheduleControls';
import MainDateRangeNav from '../ui/MainDateRangeNav';
import { withStyles } from '../utility/styles';
import { Observe } from 'rewire-core';
import { capitalize } from '../utility/StringUtils';
import mainPageModel from '../main-navigation/MainPageModel';
import MenuButton from '../ui/MenuButton';
import timecardSummaryModel from './TimecardSummaryModel';
import { timecardSummaryRouteManager } from '../main-navigation/RouteManager';
import { UTC } from 'rewire-common';

const styles = (_theme: Theme) => ({
  left: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '0 1 auto',
    flexWrap: 'wrap',
  },
  buttonWrapper: {
    marginBottom: '4px',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 1 auto',
    flexWrap: 'wrap',
  },
});

interface ITimecardSummaryProps {
  className?: string;
}

type TimecardSummaryProps = WithStyle<ReturnType<typeof styles>, ITimecardSummaryProps>;

function timecardTransitionItems(): IActionMenuItem[] {
  const allowableTransitions = timecardSummaryModel.possibleTimecardTransitions ?? [];
  if (!allowableTransitions.length) return [];

  const items: IActionMenuItem[] = [];
  for (const transition of allowableTransitions) {
    items.push({
      name: transition,
      title: capitalize(transition),
      closeOnClick: true,
      disabled: () => false,
      onClick: () => timecardSummaryModel.transitionTimecards(transition),
    });
  }
  return items;
}

class TimecardSummaryView extends React.PureComponent<TimecardSummaryProps> {
  render() {
    const { classes } = this.props;

    return (
      <MainContentToolbar>
        <div className={classes.left}>
          <Breadcrumbs />
          <MainDateRangeNav />
          <Observe
            render={() => (
              <div
                title="transition all employee timecards on this page to the selected status"
                className={classes.buttonWrapper}
                onClick={(evt) => evt.stopPropagation()}
              >
                <Observe
                  render={() => {
                    // don't remove this isloading property as it is used to determine if the button should be disabled
                    timecardSummaryModel.isLoading;
                    const endDate = timecardSummaryRouteManager.effective?.start.utc;
                    const disabled = !mainPageModel.canEditTime || !endDate || endDate > UTC.today().add(14).utc;
                    const timecardStatus = timecardSummaryModel.transitionStatus ?? 'Set Timecard Status';
                    return <MenuButton text={timecardStatus} items={timecardTransitionItems()} disabled={disabled} />;
                  }}
                />
              </div>
            )}
          />
        </div>
        <div className={classes.right}>
          <ScheduleControls hideSortBy={false} />
        </div>
      </MainContentToolbar>
    );
  }
}

export default withStyles<ITimecardSummaryProps>(styles, TimecardSummaryView);
